import { render } from "./GridControls.vue?vue&type=template&id=34ac1054"
import script from "./Script.js?vue&type=script&lang=js"
export * from "./Script.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__